module.exports = __webpack_public_path__ + "static/media/wiktionary.d52b5ca1.png";